import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../services/auth.service";
var IsLoggedInGuard = /** @class */ (function () {
    function IsLoggedInGuard(router, auth) {
        this.router = router;
        this.auth = auth;
    }
    // Validates the current session token with the server to see if user is still logged in
    IsLoggedInGuard.prototype.canLoad = function (route, segments) {
        var _this = this;
        return new Observable(function (observer) {
            _this.auth.validateSession().subscribe(function (result) {
                observer.next(true);
                observer.complete();
            }, function (error) {
                observer.next(false);
                observer.complete();
                _this.router.navigate(['/login']);
            });
        });
    };
    IsLoggedInGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        return new Observable(function (observer) {
            _this.auth.validateSession().subscribe(function (result) {
                observer.next(true);
                observer.complete();
            }, function (error) {
                observer.next(false);
                observer.complete();
                _this.router.navigate(['/login']);
            });
        });
    };
    IsLoggedInGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IsLoggedInGuard_Factory() { return new IsLoggedInGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.AuthService)); }, token: IsLoggedInGuard, providedIn: "root" });
    return IsLoggedInGuard;
}());
export { IsLoggedInGuard };
